import React, { Component } from 'react';
import { useParams } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import dayjs from 'dayjs';

const editorBtns = [['bold','italic','underline'],['fontSize','fontColor','hiliteColor'],['paragraphStyle','lineHeight'],['list','align'],['image','link'],['removeFormat']];
const editorBtnsSimple = [['bold','italic','underline'],['fontSize','lineHeight'],['list','align'],['removeFormat']];
const editorDefaultStyle = 'font-size: 16px; line-height: 1.7;';

class ProgramPlusEditInner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            airlineList: [],
            highlightMasters: [],
            iconMasters: [],
            continentMasters: [],
            countryMasters: [],
            regionMasters: [],
            provinceMasters: [],
            countries: [],
            provinces: [],
            hashtags: [],
            hashtagInput: '',
            selectedContinentId: 0,
            selectedRegionId: 0,
            saving: false,
            data: { id:0, code:'', name:'', caption:'', destinations:'', days:1, nights:0, month:'', season:'', startPrice:0, airlineId:0, specialNote:'', foodTitle:'', totalMeals:0, coverImg:'', coverSm1:'', coverSm2:'', pdfFile:'', include:'', exclude:'', bookingCondition:'', travelCondition:'', ticketCondition:'', fuelInsurance:'', baggage:'', cancellation:'', isActive:1 },
            uploading: false,
            highlights: [{ text:'', icon:'fas fa-check', sort:0 }],
            flights: [{ flightNo:'', routeFrom:'', routeTo:'', departTime:'', arriveTime:'', direction:'outbound', sort:0 }],
            foods: [],
            periods: [{ startDate:'', endDate:'', desc:'', adultPrice:0, childBed:0, childNoBed:0, singleSuppl:0, adultNoTicket:0, childBedNoTicket:0, childNoBedNoTicket:0, singleNoTicket:0, seatLimit:0, seatBooked:0 }],
            itinerary: [{ dayNo:1, title:'', breakfast:0, lunch:0, dinner:0, hotelName:'', hotelUrl:'', hotelNote:'', details:[{ dayLabel:'วันแรก', places:'', timeLabel:'', content:'', sort:0 }], images:[], icons:[] }]
        };
    }

    componentDidMount() {
        fetch('api/GetAirlinelist').then(r=>r.json()).then(j=>this.setState({airlineList:j})).catch(()=>{});
        fetch('api/programplus/highlights/master').then(r=>r.json()).then(j=>this.setState({highlightMasters:j})).catch(()=>{});
        fetch('api/programplus/icons/master').then(r=>r.json()).then(j=>this.setState({iconMasters:j})).catch(()=>{});
        fetch('api/programplus/continents/master').then(r=>r.json()).then(j=>this.setState({continentMasters:j})).catch(()=>{});
        fetch('api/programplus/countries/master').then(r=>r.json()).then(j=>this.setState({countryMasters:j})).catch(()=>{});
        fetch('api/programplus/regions/master').then(r=>r.json()).then(j=>this.setState({regionMasters:j})).catch(()=>{});
        fetch('api/programplus/provinces/master').then(r=>r.json()).then(j=>this.setState({provinceMasters:j})).catch(()=>{});
        var id = this.props.params?.id;
        if (id) this.loadData(id);
    }

    async uploadFile(folder, callback) {
        var input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = async (e) => {
            if (!e.target.files[0]) return;
            this.setState({uploading:true});
            var fd = new FormData();
            fd.append('file', e.target.files[0]);
            fd.append('folder', folder);
            try {
                var r = await fetch('api/programplus/upload', {method:'POST', body:fd});
                var res = await r.json();
                callback(res.path);
            } catch {}
            this.setState({uploading:false});
        };
        input.click();
    }

    async uploadPdf(callback) {
        var input = document.createElement('input');
        input.type = 'file';
        input.accept = '.pdf';
        input.onchange = async (e) => {
            if (!e.target.files[0]) return;
            this.setState({uploading:true});
            var fd = new FormData();
            fd.append('file', e.target.files[0]);
            fd.append('folder', 'programplus/pdf');
            try {
                var r = await fetch('api/programplus/upload', {method:'POST', body:fd});
                var res = await r.json();
                callback(res.path);
            } catch {}
            this.setState({uploading:false});
        };
        input.click();
    }

    async loadData(id) {
        try {
            var r = await fetch('api/programplus/' + id);
            if (!r.ok) return;
            var d = await r.json();
            this.setState({
                data: d.data,
                highlights: d.highlights?.length ? d.highlights : [{ text:'', icon:'fas fa-check', sort:0 }],
                flights: d.flights?.length ? d.flights : [{ flightNo:'', routeFrom:'', routeTo:'', departTime:'', arriveTime:'', direction:'outbound', sort:0 }],
                foods: d.foods || [],
                periods: d.periods?.length ? d.periods : [{ startDate:'', endDate:'', desc:'', adultPrice:0, childBed:0, childNoBed:0, singleSuppl:0, adultNoTicket:0, childBedNoTicket:0, childNoBedNoTicket:0, singleNoTicket:0, seatLimit:0, seatBooked:0 }],
                itinerary: d.itinerary?.length ? d.itinerary.map(dy=>({...dy, images: dy.images||[], icons: dy.icons||[]})) : [{ dayNo:1, title:'', breakfast:0, lunch:0, dinner:0, hotelName:'', hotelUrl:'', hotelNote:'', details:[{ dayLabel:'วันแรก', places:'', timeLabel:'', content:'', sort:0 }], images:[], icons:[] }],
                countries: d.countries || [],
                provinces: d.provinces || [],
                hashtags: d.hashtags || []
            });
        } catch {}
    }

    goStep(s) { this.setState({ step: s }, () => { try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch { window.scrollTo(0,0); } }); }

    upd(field, val) { this.setState({ data: { ...this.state.data, [field]: val } }); }
    updArr(arr, i, field, val) { var a=[...this.state[arr]]; a[i]={...a[i],[field]:val}; this.setState({[arr]:a}); }
    addArr(arr, obj) { this.setState({[arr]:[...this.state[arr], obj]}); }
    rmArr(arr, i) { var a=[...this.state[arr]]; a.splice(i,1); this.setState({[arr]:a}); }

    updDay(i, field, val) {
        var it=[...this.state.itinerary]; it[i]={...it[i],[field]:val}; this.setState({itinerary:it});
    }
    updDetail(di, deti, field, val) {
        var it=[...this.state.itinerary]; var dets=[...it[di].details]; dets[deti]={...dets[deti],[field]:val}; it[di]={...it[di],details:dets}; this.setState({itinerary:it});
    }
    addDetail(di) {
        var it=[...this.state.itinerary]; it[di]={...it[di],details:[...it[di].details,{dayLabel:'',places:'',timeLabel:'',content:'',sort:it[di].details.length}]}; this.setState({itinerary:it});
    }
    rmDetail(di, deti) {
        var it=[...this.state.itinerary]; var dets=[...it[di].details]; dets.splice(deti,1); it[di]={...it[di],details:dets}; this.setState({itinerary:it});
    }
    addDayImage(di, path) {
        var it=[...this.state.itinerary]; var imgs=[...(it[di].images||[])]; imgs.push({image:path,caption:'',sort:imgs.length}); it[di]={...it[di],images:imgs}; this.setState({itinerary:it});
    }
    updDayImage(di, ii, field, val) {
        var it=[...this.state.itinerary]; var imgs=[...it[di].images]; imgs[ii]={...imgs[ii],[field]:val}; it[di]={...it[di],images:imgs}; this.setState({itinerary:it});
    }
    rmDayImage(di, ii) {
        var it=[...this.state.itinerary]; var imgs=[...it[di].images]; imgs.splice(ii,1); it[di]={...it[di],images:imgs}; this.setState({itinerary:it});
    }
    toggleDayIcon(di, iconId) {
        var it=[...this.state.itinerary];
        var icons = [...(it[di].icons||[])];
        var existingIdx = icons.findIndex(ic => ic.iconId === iconId);
        if (existingIdx >= 0) {
            icons.splice(existingIdx, 1);
        } else {
            icons.push({ iconId: iconId, sort: icons.length });
        }
        it[di] = {...it[di], icons};
        this.setState({itinerary: it});
    }

    changeDays(val) {
        var days=parseInt(val)||1;
        var it=[...this.state.itinerary];
        var labels=['วันแรก','วันที่สอง','วันที่สาม','วันที่สี่','วันที่ห้า','วันที่หก','วันที่เจ็ด','วันที่แปด','วันที่เก้า','วันที่สิบ'];
        // Only ADD new days, never truncate (preserves existing data)
        while(it.length<days) it.push({dayNo:it.length+1,title:'',breakfast:0,lunch:0,dinner:0,hotelName:'',hotelUrl:'',hotelNote:'',details:[{dayLabel:labels[it.length]||'วันที่ '+(it.length+1),places:'',timeLabel:'',content:'',sort:0}],images:[],icons:[]});
        this.setState({data:{...this.state.data,days},itinerary:it});
    }

    async handleSave(close) {
        var {data}=this.state;
        if(!data.code||!data.name){alert('กรุณากรอกรหัสทัวร์และชื่อโปรแกรม');return;}
        this.setState({saving:true});
        try {
            var body = { data:this.state.data, highlights:this.state.highlights.filter(h=>h.text), flights:this.state.flights.filter(f=>f.flightNo), foods:this.state.foods.filter(f=>f.name), periods:this.state.periods, itinerary:this.state.itinerary, countries:this.state.countries, provinces:this.state.provinces, hashtags:this.state.hashtags };
            var r = await fetch('api/programplus',{method:'POST',headers:{'Content-Type':'application/json','X-User-Username':localStorage.getItem('username')||'','X-User-Display-Name':localStorage.getItem('displayName')||''},body:JSON.stringify(body)});
            var res = await r.json();
            this.setState({saving:false});
            if (close) {
                window.location.href='/console/programplus';
                return;
            }
            alert('บันทึกสำเร็จ!');
            if (!data.id && res?.id) {
                window.location.href = '/console/programplus/edit/' + res.id;
                return;
            }
            this.loadData(data.id);
        } catch(e) {
            this.setState({saving:false});
            alert('เกิดข้อผิดพลาด: '+e.message);
        }
    }

    renderSteps() {
        var steps=['ข้อมูลทั่วไป','เที่ยวบิน & จุดเด่น','ช่วงเดินทาง & ราคา','โปรแกรมรายวัน','เงื่อนไข'];
        return (
            <div className="d-flex justify-content-center mb-4 flex-wrap">
                {steps.map((s,i)=>(
                    <div key={i} className="d-flex align-items-center mb-1">
                        <div onClick={()=>this.goStep(i+1)} style={{width:32,height:32,borderRadius:'50%',background:this.state.step>=i+1?'#dc3545':'#dee2e6',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer',fontSize:13}}>{i+1}</div>
                        <span style={{margin:'0 6px',fontSize:12,color:this.state.step>=i+1?'#333':'#999'}}>{s}</span>
                        {i<steps.length-1&&<div style={{width:30,height:2,background:this.state.step>i+1?'#dc3545':'#dee2e6',margin:'0 2px'}}/>}
                    </div>
                ))}
            </div>
        );
    }

    renderStep1() {
        var {data,airlineList}=this.state;
        return (<div>
            <h5 className="mb-3" style={{color:'#dc3545',borderBottom:'2px solid #dc3545',paddingBottom:8}}><i className="fas fa-info-circle"></i> ข้อมูลทั่วไป</h5>
            <div className="row">
                <div className="col-md-3 mb-3"><label className="form-label fw-bold">รหัสทัวร์ *</label><input type="text" className="form-control" value={data.code} onChange={e=>this.upd('code',e.target.value)} placeholder="AJ06_3"/></div>
                <div className="col-md-9 mb-3"><label className="form-label fw-bold">ชื่อโปรแกรม *</label><input type="text" className="form-control" value={data.name} onChange={e=>this.upd('name',e.target.value)}/></div>
            </div>
            <div className="row">
                <div className="col-md-6 mb-3"><label className="form-label fw-bold">คำบรรยาย</label><input type="text" className="form-control" value={data.caption} onChange={e=>this.upd('caption',e.target.value)} placeholder="(KYOTO ONSEN)"/></div>
                <div className="col-md-6 mb-3"><label className="form-label fw-bold">สถานที่เที่ยว</label><input type="text" className="form-control" value={data.destinations} onChange={e=>this.upd('destinations',e.target.value)} placeholder="โอซาก้า อาราชิยาม่า เกียวโต โกเบ"/></div>
            </div>
            <div className="row">
                <div className="col-md-2 mb-3"><label className="form-label fw-bold">จำนวนวัน</label><input type="number" className="form-control" min="1" value={data.days} onChange={e=>this.changeDays(e.target.value)}/></div>
                <div className="col-md-2 mb-3"><label className="form-label fw-bold">จำนวนคืน</label><input type="number" className="form-control" min="0" value={data.nights} onChange={e=>this.upd('nights',parseInt(e.target.value)||0)}/></div>
                <div className="col-md-3 mb-3"><label className="form-label fw-bold">สายการบิน</label><select className="form-control" style={{color:'#333'}} value={data.airlineId} onChange={e=>this.upd('airlineId',parseInt(e.target.value))}><option value="0" style={{color:'#333'}}>-- เลือก --</option>{airlineList.map(a=><option key={a.id} value={a.id} style={{color:'#333'}}>{a.name}</option>)}</select></div>
                <div className="col-md-2 mb-3"><label className="form-label fw-bold">เดือน</label><input type="text" className="form-control" value={data.month} onChange={e=>this.upd('month',e.target.value)} placeholder="APR 2026"/></div>
                <div className="col-md-3 mb-3"><label className="form-label fw-bold">ราคาเริ่มต้น</label><input type="number" className="form-control" value={data.startPrice} onChange={e=>this.upd('startPrice',parseFloat(e.target.value)||0)}/></div>
            </div>
            <div className="row">
                <div className="col-md-6 mb-3"><label className="form-label fw-bold">พิเศษยิ่งกว่า (หมายเหตุพิเศษ)</label><textarea className="form-control" rows="3" value={data.specialNote} onChange={e=>this.upd('specialNote',e.target.value)} placeholder="พักโรงแรมมีออนเซน 1 คืน&#10;(สามารถพิมพ์หลายบรรทัดได้)" /></div>
                <div className="col-md-3 mb-3"><label className="form-label fw-bold">อาหารรวม (มื้อ)</label><input type="number" className="form-control" value={data.totalMeals} onChange={e=>this.upd('totalMeals',parseInt(e.target.value)||0)}/></div>
            </div>

            <h6 className="mt-4 mb-3" style={{color:'#dc3545'}}><i className="fas fa-globe-asia"></i> ทวีป / ประเทศ / สถานที่ / Hashtag</h6>
            <div className="row mb-2">
                <div className="col-md-3 mb-2">
                    <label className="form-label fw-bold">1. ทวีป (เลือกเพื่อกรองประเทศ)</label>
                    <select className="form-control" style={{color:'#333'}} value={this.state.selectedContinentId}
                        onChange={e=>this.setState({selectedContinentId:parseInt(e.target.value)})}>
                        <option value="0" style={{color:'#333'}}>-- เลือกทวีป --</option>
                        {this.state.continentMasters.map(c=>(
                            <option key={c.id} value={c.id} style={{color:'#333'}}>{c.name}</option>
                        ))}
                    </select>
                </div>
                <div className="col-md-4 mb-2">
                    <label className="form-label fw-bold">2. ประเทศ (เลือกเพิ่มได้หลาย)</label>
                    <select className="form-control" style={{color:'#333'}} value="0"
                        disabled={this.state.selectedContinentId<=0}
                        onChange={e=>{
                            var id = parseInt(e.target.value); if(id<=0) return;
                            if (this.state.countries.find(c=>c.id===id)) return;
                            var m = this.state.countryMasters.find(c=>c.id===id);
                            this.setState({countries:[...this.state.countries, {id, name: m?m.name:''}]});
                        }}>
                        <option value="0" style={{color:'#333'}}>{this.state.selectedContinentId<=0?'-- เลือกทวีปก่อน --':'+ เพิ่มประเทศ...'}</option>
                        {this.state.countryMasters.filter(c=>c.continentId===this.state.selectedContinentId).map(c=>(
                            <option key={c.id} value={c.id} style={{color:'#333'}}>{c.name}</option>
                        ))}
                    </select>
                </div>
                <div className="col-md-5 mb-2">
                    <label className="form-label fw-bold">3. ภูมิภาค (สำหรับกรอง)</label>
                    <select className="form-control" style={{color:'#333'}}
                        value={this.state.selectedRegionId}
                        disabled={this.state.countries.length===0}
                        onChange={e=>this.setState({selectedRegionId: parseInt(e.target.value)})}>
                        <option value="0" style={{color:'#333'}}>{this.state.countries.length===0?'-- เลือกประเทศก่อน --':'-- ทุกภูมิภาค --'}</option>
                        {this.state.regionMasters
                            .filter(r => this.state.countries.some(c=>c.id===r.countryId))
                            .map(r=>(
                                <option key={r.id} value={r.id} style={{color:'#333'}}>{r.name}</option>
                            ))}
                    </select>
                </div>
                <div className="col-md-12 mb-2">
                    <label className="form-label fw-bold">4. จังหวัด / Province {this.state.countries.length>0?'(กรองตามประเทศ/ภูมิภาคที่เลือก)':''}</label>
                    <select className="form-control" style={{color:'#333'}} value="0"
                        disabled={this.state.countries.length===0}
                        onChange={e=>{
                            var id = parseInt(e.target.value); if(id<=0) return;
                            if (this.state.provinces.find(p=>p.id===id)) return;
                            var m = this.state.provinceMasters.find(p=>p.id===id);
                            var reg = m ? this.state.regionMasters.find(r=>r.id===m.regionId) : null;
                            this.setState({provinces:[...this.state.provinces, {id, name: m?m.name:'', regionId: m?m.regionId:0, regionName: reg?reg.name:''}]});
                        }}>
                        <option value="0" style={{color:'#333'}}>{this.state.countries.length===0?'-- เลือกประเทศก่อน --':'+ เพิ่มจังหวัด...'}</option>
                        {this.state.provinceMasters
                            .filter(p => this.state.countries.some(c=>c.id===p.countryId))
                            .filter(p => this.state.selectedRegionId===0 || p.regionId===this.state.selectedRegionId)
                            .map(p=>{
                                var reg = this.state.regionMasters.find(r=>r.id===p.regionId);
                                return <option key={p.id} value={p.id} style={{color:'#333'}}>{reg?reg.name+' / ':''}{p.name}</option>;
                            })}
                    </select>
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-md-6">
                    <label className="form-label" style={{fontSize:12,color:'#666'}}>ประเทศที่เลือก</label>
                    <div className="d-flex flex-wrap" style={{gap:6,minHeight:32,padding:6,background:'#fafafa',borderRadius:6}}>
                        {this.state.countries.length===0 && <span style={{color:'#bbb',fontSize:12}}>ยังไม่ได้เลือกประเทศ</span>}
                        {this.state.countries.map((c,i)=>(
                            <span key={i} style={{background:'#dc3545',color:'#fff',padding:'4px 10px',borderRadius:20,fontSize:12,display:'inline-flex',alignItems:'center',gap:6}}>
                                <i className="fas fa-flag"></i>{c.name}
                                <button type="button" style={{background:'none',border:'none',color:'#fff',padding:0,cursor:'pointer'}} onClick={()=>{
                                    var arr=[...this.state.countries];arr.splice(i,1);
                                    // Also remove provinces that belong only to removed country
                                    var provs = this.state.provinces.filter(p=>{
                                        var pm = this.state.provinceMasters.find(x=>x.id===p.id);
                                        return pm && arr.some(cc=>cc.id===pm.countryId);
                                    });
                                    this.setState({countries:arr, provinces:provs});
                                }}><i className="fas fa-times"></i></button>
                            </span>
                        ))}
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label" style={{fontSize:12,color:'#666'}}>จังหวัดที่เลือก</label>
                    <div className="d-flex flex-wrap" style={{gap:6,minHeight:32,padding:6,background:'#fafafa',borderRadius:6}}>
                        {this.state.provinces.length===0 && <span style={{color:'#bbb',fontSize:12}}>ยังไม่ได้เลือกจังหวัด</span>}
                        {this.state.provinces.map((p,i)=>(
                            <span key={i} style={{background:'#6c757d',color:'#fff',padding:'4px 10px',borderRadius:20,fontSize:12,display:'inline-flex',alignItems:'center',gap:6}}>
                                <i className="fas fa-map"></i>{p.name}{p.regionName?' ('+p.regionName+')':''}
                                <button type="button" style={{background:'none',border:'none',color:'#fff',padding:0,cursor:'pointer'}} onClick={()=>{var arr=[...this.state.provinces];arr.splice(i,1);this.setState({provinces:arr});}}><i className="fas fa-times"></i></button>
                            </span>
                        ))}
                    </div>
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-md-12 mb-2">
                    <label className="form-label fw-bold">Hashtag (พิมพ์แล้วกด Enter)</label>
                    <input type="text" className="form-control" value={this.state.hashtagInput}
                        placeholder="เช่น ซากุระ, ออนเซ็น, ครอบครัว..."
                        onChange={e=>this.setState({hashtagInput:e.target.value})}
                        onKeyDown={e=>{
                            if(e.key==='Enter'){
                                e.preventDefault();
                                var v=this.state.hashtagInput.trim().replace(/^#/,'');
                                if(v && !this.state.hashtags.includes(v)){
                                    this.setState({hashtags:[...this.state.hashtags, v], hashtagInput:''});
                                }
                            }
                        }}/>
                    <div className="d-flex flex-wrap mt-2" style={{gap:6}}>
                        {this.state.hashtags.map((t,i)=>(
                            <span key={i} style={{background:'#0d6efd',color:'#fff',padding:'4px 10px',borderRadius:20,fontSize:12,display:'inline-flex',alignItems:'center',gap:6}}>
                                #{t}
                                <button type="button" style={{background:'none',border:'none',color:'#fff',padding:0,cursor:'pointer'}} onClick={()=>{var arr=[...this.state.hashtags];arr.splice(i,1);this.setState({hashtags:arr});}}><i className="fas fa-times"></i></button>
                            </span>
                        ))}
                    </div>
                </div>
            </div>

            <h6 className="mt-4 mb-3" style={{color:'#dc3545'}}><i className="fas fa-images"></i> ภาพปก</h6>
            <div className="row">
                <div className="col-md-4 mb-3">
                    <label className="form-label" style={{fontSize:13}}>ภาพปกใหญ่</label>
                    <div className="border rounded p-2 text-center" style={{minHeight:120,background:'#fafafa',cursor:'pointer'}} onClick={()=>this.uploadFile('programplus/cover',p=>this.upd('coverImg',p))}>
                        {data.coverImg ? <img src={data.coverImg} alt="" style={{maxHeight:120,maxWidth:'100%',borderRadius:6}}/> : <div style={{color:'#bbb',paddingTop:40}}><i className="fas fa-cloud-upload-alt fa-2x"></i><br/>คลิกเพื่ออัพโหลด</div>}
                    </div>
                </div>
                <div className="col-md-4 mb-3">
                    <label className="form-label" style={{fontSize:13}}>ภาพเล็กที่ 1</label>
                    <div className="border rounded p-2 text-center" style={{minHeight:120,background:'#fafafa',cursor:'pointer'}} onClick={()=>this.uploadFile('programplus/cover',p=>this.upd('coverSm1',p))}>
                        {data.coverSm1 ? <img src={data.coverSm1} alt="" style={{maxHeight:120,maxWidth:'100%',borderRadius:6}}/> : <div style={{color:'#bbb',paddingTop:40}}><i className="fas fa-cloud-upload-alt fa-2x"></i><br/>คลิกเพื่ออัพโหลด</div>}
                    </div>
                </div>
                <div className="col-md-4 mb-3">
                    <label className="form-label" style={{fontSize:13}}>ภาพเล็กที่ 2</label>
                    <div className="border rounded p-2 text-center" style={{minHeight:120,background:'#fafafa',cursor:'pointer'}} onClick={()=>this.uploadFile('programplus/cover',p=>this.upd('coverSm2',p))}>
                        {data.coverSm2 ? <img src={data.coverSm2} alt="" style={{maxHeight:120,maxWidth:'100%',borderRadius:6}}/> : <div style={{color:'#bbb',paddingTop:40}}><i className="fas fa-cloud-upload-alt fa-2x"></i><br/>คลิกเพื่ออัพโหลด</div>}
                    </div>
                </div>
            </div>

            <h6 className="mt-3 mb-2"><i className="fas fa-file-pdf" style={{color:'#dc3545'}}></i> ไฟล์ PDF</h6>
            <div className="d-flex align-items-center" style={{gap:10}}>
                <button className="btn btn-outline-primary btn-sm" onClick={()=>this.uploadPdf(p=>this.upd('pdfFile',p))}><i className="fas fa-upload"></i> อัพโหลด PDF</button>
                {data.pdfFile && <span><a href={data.pdfFile} target="_blank" rel="noopener noreferrer"><i className="fas fa-file-pdf" style={{color:'#dc3545'}}></i> {data.pdfFile.split('/').pop()}</a>
                    <button className="btn btn-outline-danger btn-sm ms-2" style={{marginLeft:6}} onClick={()=>this.upd('pdfFile','')}><i className="fas fa-times"></i></button></span>}
            </div>
            {this.state.uploading && <div className="mt-2" style={{color:'#999'}}><i className="fas fa-spinner fa-spin"></i> กำลังอัพโหลด...</div>}
        </div>);
    }

    renderStep2() {
        var {highlights,flights,foods}=this.state;
        return (<div>
            <h5 className="mb-3" style={{color:'#dc3545',borderBottom:'2px solid #dc3545',paddingBottom:8}}><i className="fas fa-plane"></i> เที่ยวบินและจุดเด่น</h5>

            <h6 className="mt-3 mb-2"><i className="fas fa-plane-departure"></i> เที่ยวบิน</h6>
            {flights.map((f,i)=>(
                <div key={i} className="row mb-2 align-items-end">
                    <div className="col-md-2"><label style={{fontSize:12}}>เที่ยวบิน</label><input className="form-control form-control-sm" value={f.flightNo} onChange={e=>this.updArr('flights',i,'flightNo',e.target.value)} placeholder="JL 728"/></div>
                    <div className="col-md-2"><label style={{fontSize:12}}>จาก</label><input className="form-control form-control-sm" value={f.routeFrom} onChange={e=>this.updArr('flights',i,'routeFrom',e.target.value)} placeholder="BKK"/></div>
                    <div className="col-md-2"><label style={{fontSize:12}}>ถึง</label><input className="form-control form-control-sm" value={f.routeTo} onChange={e=>this.updArr('flights',i,'routeTo',e.target.value)} placeholder="KIX"/></div>
                    <div className="col-md-2"><label style={{fontSize:12}}>ออก</label><input className="form-control form-control-sm" value={f.departTime} onChange={e=>this.updArr('flights',i,'departTime',e.target.value)} placeholder="00.25"/></div>
                    <div className="col-md-2"><label style={{fontSize:12}}>ถึง</label><input className="form-control form-control-sm" value={f.arriveTime} onChange={e=>this.updArr('flights',i,'arriveTime',e.target.value)} placeholder="07.50"/></div>
                    <div className="col-md-1"><select className="form-control form-control-sm" value={f.direction} onChange={e=>this.updArr('flights',i,'direction',e.target.value)}><option value="outbound">ไป</option><option value="inbound">กลับ</option></select></div>
                    <div className="col-md-1"><button className="btn btn-outline-danger btn-sm" onClick={()=>this.rmArr('flights',i)}><i className="fas fa-times"></i></button></div>
                </div>
            ))}
            <button className="btn btn-outline-secondary btn-sm mb-4" onClick={()=>this.addArr('flights',{flightNo:'',routeFrom:'',routeTo:'',departTime:'',arriveTime:'',direction:'outbound',sort:flights.length})}><i className="fas fa-plus"></i> เพิ่มเที่ยวบิน</button>

            <h6 className="mt-3 mb-2"><i className="fas fa-star"></i> ทำไมต้องไปกับเรา?</h6>
            {highlights.map((h,i)=>{
                var matched = this.state.highlightMasters.find(m=>m.text===h.text && m.icon===h.icon);
                return (
                    <div key={i} className="d-flex align-items-center mb-2" style={{gap:8}}>
                        <i className={h.icon||'fas fa-check'} style={{color:'#dc3545',width:20,textAlign:'center'}}></i>
                        <select className="form-control form-control-sm" style={{color:'#333'}} value={matched?matched.id:0}
                            onChange={e=>{
                                var m = this.state.highlightMasters.find(m=>m.id===parseInt(e.target.value));
                                var hl=[...this.state.highlights];
                                hl[i]={...hl[i], text: m?m.text:'', icon: m?m.icon:'fas fa-check'};
                                this.setState({highlights:hl});
                            }}>
                            <option value="0" style={{color:'#333'}}>-- เลือกจุดเด่น --</option>
                            {this.state.highlightMasters.map(m=>(
                                <option key={m.id} value={m.id} style={{color:'#333'}}>{m.text}</option>
                            ))}
                        </select>
                        <button className="btn btn-outline-danger btn-sm" onClick={()=>this.rmArr('highlights',i)}><i className="fas fa-times"></i></button>
                    </div>
                );
            })}
            <button className="btn btn-outline-secondary btn-sm mb-4" onClick={()=>this.addArr('highlights',{text:'',icon:'fas fa-check',sort:highlights.length})}><i className="fas fa-plus"></i> เพิ่มจุดเด่น</button>

            <h6 className="mt-3 mb-2"><i className="fas fa-star"></i> รายการแนะนำ (เมนูเด็ด / กิจกรรม / สถานที่ ฯลฯ)</h6>
            <div className="mb-2">
                <label style={{fontSize:12}}>หัวข้อที่แสดงในหน้าโปรแกรม</label>
                <input className="form-control form-control-sm" value={this.state.data.foodTitle||''} onChange={e=>this.upd('foodTitle',e.target.value)} placeholder="เช่น ไม่พลาดเมนูเด็ด! / กิจกรรมห้ามพลาด / สถานที่แนะนำ"/>
            </div>
            {foods.map((f,i)=>(
                <div key={i} className="border rounded p-2 mb-2" style={{background:'#fafafa'}}>
                    <div className="row align-items-center">
                        <div className="col-md-2 text-center">
                            <div style={{width:80,height:80,border:'1px dashed #ccc',borderRadius:8,background:'#fff',cursor:'pointer',overflow:'hidden',margin:'auto'}} onClick={()=>this.uploadFile('programplus/food',p=>this.updArr('foods',i,'image',p))}>
                                {f.image ? <img src={f.image} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}}/> : <div style={{color:'#ccc',paddingTop:25}}><i className="fas fa-camera fa-lg"></i><br/><small>รูป</small></div>}
                            </div>
                        </div>
                        <div className="col-md-3"><label style={{fontSize:12}}>ชื่อ</label><input className="form-control form-control-sm" value={f.name} onChange={e=>this.updArr('foods',i,'name',e.target.value)} placeholder="เช่น Shabu Shabu / ล่องเรือ / วัดคินคะคุจิ"/></div>
                        <div className="col-md-6"><label style={{fontSize:12}}>คำบรรยาย</label><input className="form-control form-control-sm" value={f.desc} onChange={e=>this.updArr('foods',i,'desc',e.target.value)} placeholder="คำอธิบายสั้นๆ"/></div>
                        <div className="col-md-1 text-end"><button className="btn btn-outline-danger btn-sm" onClick={()=>this.rmArr('foods',i)}><i className="fas fa-times"></i></button></div>
                    </div>
                </div>
            ))}
            <button className="btn btn-outline-secondary btn-sm" onClick={()=>this.addArr('foods',{name:'',desc:'',image:'',sort:foods.length})}><i className="fas fa-plus"></i> เพิ่มรายการ</button>
        </div>);
    }

    renderStep3() {
        var {periods}=this.state;
        return (<div>
            <h5 className="mb-3" style={{color:'#dc3545',borderBottom:'2px solid #dc3545',paddingBottom:8}}><i className="fas fa-calendar-alt"></i> ช่วงเดินทางและราคา</h5>
            {periods.map((p,i)=>(
                <div key={i} className="card mb-3">
                    <div className="card-header d-flex justify-content-between" style={{background:'#f8f9fa'}}><strong>ช่วงที่ {i+1}</strong>{periods.length>1&&<button className="btn btn-outline-danger btn-sm" onClick={()=>this.rmArr('periods',i)}><i className="fas fa-trash"></i></button>}</div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-3 mb-2">
                                <label className="form-label fw-bold d-block">วันเริ่มเดินทาง</label>
                                <DatePicker className="form-control" dateFormat="dd/MM/yyyy" selected={p.startDate?new Date(p.startDate):null}
                                    onChange={e=>{
                                        var startStr = dayjs(e).format('YYYY-MM-DD');
                                        var periods=[...this.state.periods];
                                        periods[i]={...periods[i], startDate: startStr};
                                        // Auto-fill end date based on days
                                        var days = parseInt(this.state.data.days)||1;
                                        if(days > 1){
                                            periods[i].endDate = dayjs(e).add(days-1,'day').format('YYYY-MM-DD');
                                        }
                                        this.setState({periods});
                                    }}
                                    peekNextMonth showMonthDropdown showYearDropdown dropdownMode="select"/>
                            </div>
                            <div className="col-md-3 mb-2">
                                <label className="form-label fw-bold d-block">วันสิ้นสุดเดินทาง</label>
                                <DatePicker className="form-control" dateFormat="dd/MM/yyyy" selected={p.endDate?new Date(p.endDate):null}
                                    onChange={e=>this.updArr('periods',i,'endDate',dayjs(e).format('YYYY-MM-DD'))}
                                    peekNextMonth showMonthDropdown showYearDropdown dropdownMode="select"/>
                            </div>
                            <div className="col-md-3 mb-2"><label className="form-label fw-bold">ที่นั่ง</label><input type="number" className="form-control" value={p.seatLimit} onChange={e=>this.updArr('periods',i,'seatLimit',parseInt(e.target.value)||0)}/></div>
                            <div className="col-md-3 mb-2"><label className="form-label fw-bold">หมายเหตุ</label><input type="text" className="form-control" value={p.desc} onChange={e=>this.updArr('periods',i,'desc',e.target.value)}/></div>
                        </div>
                        <div className="row"><div className="col-12"><strong>ราคารวมตั๋ว</strong></div></div>
                        <div className="row">
                            <div className="col-md-3 mb-2"><label style={{fontSize:12}}>ผู้ใหญ่</label><input type="number" className="form-control form-control-sm" value={p.adultPrice} onChange={e=>this.updArr('periods',i,'adultPrice',parseFloat(e.target.value)||0)}/></div>
                            <div className="col-md-3 mb-2"><label style={{fontSize:12}}>เด็ก (มีเตียง)</label><input type="number" className="form-control form-control-sm" value={p.childBed} onChange={e=>this.updArr('periods',i,'childBed',parseFloat(e.target.value)||0)}/></div>
                            <div className="col-md-3 mb-2"><label style={{fontSize:12}}>เด็ก (ไม่มีเตียง)</label><input type="number" className="form-control form-control-sm" value={p.childNoBed} onChange={e=>this.updArr('periods',i,'childNoBed',parseFloat(e.target.value)||0)}/></div>
                            <div className="col-md-3 mb-2"><label style={{fontSize:12}}>พักเดี่ยว เพิ่ม</label><input type="number" className="form-control form-control-sm" value={p.singleSuppl} onChange={e=>this.updArr('periods',i,'singleSuppl',parseFloat(e.target.value)||0)}/></div>
                        </div>
                        <div className="row"><div className="col-12"><strong>ราคาไม่รวมตั๋ว</strong></div></div>
                        <div className="row">
                            <div className="col-md-3 mb-2"><label style={{fontSize:12}}>ผู้ใหญ่</label><input type="number" className="form-control form-control-sm" value={p.adultNoTicket} onChange={e=>this.updArr('periods',i,'adultNoTicket',parseFloat(e.target.value)||0)}/></div>
                            <div className="col-md-3 mb-2"><label style={{fontSize:12}}>เด็ก (มีเตียง)</label><input type="number" className="form-control form-control-sm" value={p.childBedNoTicket} onChange={e=>this.updArr('periods',i,'childBedNoTicket',parseFloat(e.target.value)||0)}/></div>
                            <div className="col-md-3 mb-2"><label style={{fontSize:12}}>เด็ก (ไม่มีเตียง)</label><input type="number" className="form-control form-control-sm" value={p.childNoBedNoTicket} onChange={e=>this.updArr('periods',i,'childNoBedNoTicket',parseFloat(e.target.value)||0)}/></div>
                            <div className="col-md-3 mb-2"><label style={{fontSize:12}}>พักเดี่ยว เพิ่ม</label><input type="number" className="form-control form-control-sm" value={p.singleNoTicket} onChange={e=>this.updArr('periods',i,'singleNoTicket',parseFloat(e.target.value)||0)}/></div>
                        </div>
                    </div>
                </div>
            ))}
            <button className="btn btn-outline-secondary" onClick={()=>this.addArr('periods',{startDate:'',endDate:'',desc:'',adultPrice:0,childBed:0,childNoBed:0,singleSuppl:0,adultNoTicket:0,childBedNoTicket:0,childNoBedNoTicket:0,singleNoTicket:0,seatLimit:0,seatBooked:0})}><i className="fas fa-plus"></i> เพิ่มช่วงเดินทาง</button>
        </div>);
    }

    renderStep4() {
        var {itinerary}=this.state;
        return (<div>
            <h5 className="mb-3" style={{color:'#dc3545',borderBottom:'2px solid #dc3545',paddingBottom:8}}><i className="fas fa-route"></i> โปรแกรมรายวัน</h5>
            {itinerary.map((day,di)=>(
                <div key={di} className="card mb-3">
                    <div className="card-header" style={{background:di===0?'#dc3545':'#f8f9fa',color:di===0?'#fff':'#333'}}><strong>วันที่ {day.dayNo}</strong></div>
                    <div className="card-body">
                        <div className="row mb-2">
                            <div className="col-md-8"><label className="form-label fw-bold">สถานที่ / หัวข้อ</label><input type="text" className="form-control" value={day.title} onChange={e=>this.updDay(di,'title',e.target.value)}/></div>
                            <div className="col-md-4">
                                <label className="form-label">มื้ออาหาร</label>
                                <div className="d-flex" style={{gap:16}}>
                                    <label style={{fontSize:13}}><input type="checkbox" checked={day.breakfast===1} onChange={e=>this.updDay(di,'breakfast',e.target.checked?1:0)}/> เช้า</label>
                                    <label style={{fontSize:13}}><input type="checkbox" checked={day.lunch===1} onChange={e=>this.updDay(di,'lunch',e.target.checked?1:0)}/> กลางวัน</label>
                                    <label style={{fontSize:13}}><input type="checkbox" checked={day.dinner===1} onChange={e=>this.updDay(di,'dinner',e.target.checked?1:0)}/> เย็น</label>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-5"><label className="form-label">โรงแรม</label><input className="form-control form-control-sm" value={day.hotelName} onChange={e=>this.updDay(di,'hotelName',e.target.value)} placeholder="ชื่อโรงแรม"/></div>
                            <div className="col-md-4"><label className="form-label">URL</label><input className="form-control form-control-sm" value={day.hotelUrl} onChange={e=>this.updDay(di,'hotelUrl',e.target.value)}/></div>
                            <div className="col-md-3"><label className="form-label">หมายเหตุ</label><input className="form-control form-control-sm" value={day.hotelNote} onChange={e=>this.updDay(di,'hotelNote',e.target.value)} placeholder="หรือเทียบเท่า"/></div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-bold"><i className="fas fa-tags"></i> สัญลักษณ์ / Icon ของวันนี้</label>
                            <div className="d-flex flex-wrap" style={{gap:6}}>
                                {this.state.iconMasters.map(im=>{
                                    var isSelected = (day.icons||[]).some(ic=>ic.iconId===im.id);
                                    return (
                                        <button key={im.id} type="button" onClick={()=>this.toggleDayIcon(di,im.id)}
                                            style={{
                                                background:isSelected?'#dc3545':'#fff',
                                                color:isSelected?'#fff':'#666',
                                                border:'1px solid '+(isSelected?'#dc3545':'#ddd'),
                                                borderRadius:20, padding:'4px 10px', fontSize:12, cursor:'pointer'
                                            }}>
                                            <i className={im.iconClass}></i> {im.name}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>

                        <h6><i className="fas fa-clock"></i> รายละเอียดแต่ละช่วง</h6>
                        {(day.details||[]).map((det,deti)=>(
                            <div key={deti} className="border rounded p-2 mb-2" style={{background:'#fafafa'}}>
                                <div className="row mb-2">
                                    <div className="col-md-2"><label style={{fontSize:12}}>ชื่อวัน</label><input className="form-control form-control-sm" value={det.dayLabel} onChange={e=>this.updDetail(di,deti,'dayLabel',e.target.value)} placeholder="วันแรก"/></div>
                                    <div className="col-md-5"><label style={{fontSize:12}}>สถานที่</label><input className="form-control form-control-sm" value={det.places} onChange={e=>this.updDetail(di,deti,'places',e.target.value)}/></div>
                                    <div className="col-md-2"><label style={{fontSize:12}}>เวลา</label><input className="form-control form-control-sm" value={det.timeLabel} onChange={e=>this.updDetail(di,deti,'timeLabel',e.target.value)} placeholder="21.30 น."/></div>
                                    <div className="col-md-3 text-end"><button className="btn btn-outline-danger btn-sm mt-3" onClick={()=>this.rmDetail(di,deti)}><i className="fas fa-times"></i></button></div>
                                </div>
                                <SunEditor setContents={det.content} onChange={c=>this.updDetail(di,deti,'content',c)} setDefaultStyle={editorDefaultStyle} setOptions={{height:220,buttonList:editorBtns}}/>
                            </div>
                        ))}
                        <button className="btn btn-outline-secondary btn-sm" onClick={()=>this.addDetail(di)}><i className="fas fa-plus"></i> เพิ่มช่วงเวลา</button>

                        <h6 className="mt-4"><i className="fas fa-images"></i> รูปประกอบวันนี้</h6>
                        <div className="d-flex flex-wrap" style={{gap:8}}>
                            {(day.images||[]).map((img,ii)=>(
                                <div key={ii} style={{position:'relative',width:120}}>
                                    <img src={img.image} alt="" style={{width:120,height:90,objectFit:'cover',borderRadius:6,border:'1px solid #ddd'}}/>
                                    <button className="btn btn-danger btn-sm" style={{position:'absolute',top:-6,right:-6,width:24,height:24,padding:0,borderRadius:'50%',fontSize:10}} onClick={()=>this.rmDayImage(di,ii)}><i className="fas fa-times"></i></button>
                                    <input className="form-control form-control-sm mt-1" style={{fontSize:11}} placeholder="คำบรรยาย" value={img.caption} onChange={e=>this.updDayImage(di,ii,'caption',e.target.value)}/>
                                </div>
                            ))}
                            <div style={{width:120,height:90,border:'2px dashed #ccc',borderRadius:6,display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',cursor:'pointer',color:'#aaa'}} onClick={()=>this.uploadFile('programplus/day',p=>this.addDayImage(di,p))}>
                                <i className="fas fa-plus fa-lg"></i>
                                <small>เพิ่มรูป</small>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>);
    }

    renderStep5() {
        var {data}=this.state;
        var sections = [
            {key:'include',label:'อัตรานี้รวม',icon:'fas fa-check-circle',color:'#28a745'},
            {key:'exclude',label:'อัตรานี้ไม่รวม',icon:'fas fa-times-circle',color:'#dc3545'},
            {key:'bookingCondition',label:'เงื่อนไขการจอง',icon:'fas fa-file-contract',color:'#333'},
            {key:'travelCondition',label:'เงื่อนไขการเดินทาง',icon:'fas fa-route',color:'#333'},
            {key:'ticketCondition',label:'ตั๋วเครื่องบิน',icon:'fas fa-ticket-alt',color:'#333'},
            {key:'fuelInsurance',label:'ค่าธรรมเนียมน้ำมันเชื้อเพลิงและค่าประกันวินาศภัยทางอากาศ',icon:'fas fa-gas-pump',color:'#333'},
            {key:'baggage',label:'กระเป๋าและสัมภาระการเดินทาง',icon:'fas fa-suitcase',color:'#333'},
            {key:'cancellation',label:'กรณียกเลิกการเดินทาง',icon:'fas fa-ban',color:'#dc3545'}
        ];
        return (<div>
            <h5 className="mb-3" style={{color:'#dc3545',borderBottom:'2px solid #dc3545',paddingBottom:8}}><i className="fas fa-file-contract"></i> เงื่อนไขและข้อกำหนด</h5>
            {sections.map(s=>(
                <div key={s.key} className="mb-4">
                    <h6 style={{color:s.color}}><i className={s.icon}></i> {s.label}</h6>
                    <SunEditor setContents={data[s.key]||''} onChange={c=>this.upd(s.key,c)} setDefaultStyle={editorDefaultStyle} setOptions={{height:180,buttonList:editorBtnsSimple}}/>
                </div>
            ))}
        </div>);
    }

    render() {
        var {step,saving,data}=this.state;
        var isEdit = data.id > 0;
        return (
            <div style={{padding:20,maxWidth:1100,margin:'0 auto'}}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div></div>
                    <div className="d-flex align-items-center" style={{gap:12}}>
                        <div className="btn-group" role="group">
                            <button type="button" className={'btn btn-sm '+(data.isActive!==0?'btn-success':'btn-outline-success')} onClick={()=>this.upd('isActive',1)}>
                                <i className="fas fa-check-circle"></i> Active
                            </button>
                            <button type="button" className={'btn btn-sm '+(data.isActive===0?'btn-secondary':'btn-outline-secondary')} onClick={()=>this.upd('isActive',0)}>
                                <i className="fas fa-pause-circle"></i> Inactive
                            </button>
                        </div>
                        <a href="/console/programplus" className="btn btn-outline-secondary btn-sm"><i className="fas fa-arrow-left"></i> กลับ</a>
                    </div>
                </div>
                {this.renderSteps()}
                <div className="card">
                    <div className="card-body" style={{minHeight:400}}>
                        {step===1&&this.renderStep1()}
                        {step===2&&this.renderStep2()}
                        {step===3&&this.renderStep3()}
                        {step===4&&this.renderStep4()}
                        {step===5&&this.renderStep5()}
                    </div>
                    <div className="card-footer d-flex justify-content-between">
                        <button className="btn btn-secondary" disabled={step===1} onClick={()=>this.goStep(step-1)}><i className="fas fa-chevron-left"></i> ย้อนกลับ</button>
                        <div className="d-flex" style={{gap:8}}>
                            {step<5 && <button className="btn btn-primary" onClick={()=>this.goStep(step+1)}>ถัดไป <i className="fas fa-chevron-right"></i></button>}
                            {(isEdit || step===5) && <>
                                <button className="btn btn-outline-danger" disabled={saving} onClick={()=>this.handleSave(false)}><i className="fas fa-save"></i> {saving?'กำลังบันทึก...':'บันทึก'}</button>
                                <button className="btn btn-danger" disabled={saving} onClick={()=>this.handleSave(true)}><i className="fas fa-check"></i> {saving?'กำลังบันทึก...':'บันทึกแล้วปิด'}</button>
                            </>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function ProgramPlusEdit(props) {
    var params = useParams();
    return <ProgramPlusEditInner {...props} params={params}/>;
}
